<div
  id="printable-section"
  class="applicationContent"
  [innerHTML]="content() | safeHtml"
></div>

<div class="flex justify-end gap-5 mt-8">
  <p-button
    styleClass="customInfoButton"
    size="small"
    type="submit"
    (click)="printSection()"
    [label]="'Drukuj'"
  />
  <p-button
    styleClass="customInfoButton"
    size="small"
    type="submit"
    (click)="dynamicDialogRef.close()"
    [label]="'Wyjdź'"
  />
</div>
